import { z } from 'zod';
import { SsoRegisterUserSchema } from './sso-register-user-params';
export const SsoAccountMergeSchema = SsoRegisterUserSchema.extend({
    email: z.string(),
    password: z.string(),
});
